import type {LayoutRowPartWidth} from 'shared/layouts';
import {createContext, getContextOrThrow} from 'src/core';
import {hasContext, setContext} from 'svelte';

export const gridSystemContextKey = Symbol('grid-system-ctx');
export const gridSystemRowContextKey = Symbol('grid-system-row-ctx');

export interface GridSystemContext {
    rowWidth: LayoutRowPartWidth;
}

export interface GridSystemRowContext {
    columnsCount: number;
}

export function createGridSystemContext(rowWidth: LayoutRowPartWidth): GridSystemContext {
    return createContext<GridSystemContext>(gridSystemContextKey, {
        rowWidth
    });
}

export function getGridSystemContext(): GridSystemContext {
    return getContextOrThrow<GridSystemContext>(gridSystemContextKey);
}

export function createGridSystemRowContext(columnRatios: number[]): GridSystemRowContext {
    if (!hasContext(gridSystemContextKey)) {
        throw new Error('You can only create Row Grid context in Grid System context, but it does not exist! Use `createGridSystemContext` function to create it in a parent component.');
    }

    return setContext<GridSystemRowContext>(gridSystemRowContextKey, {
        columnsCount: columnRatios.length
    });
}

export function getGridSystemRowContext(): GridSystemRowContext {
    return getContextOrThrow<GridSystemRowContext>(gridSystemContextKey);
}
